(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    function parseJSON(el) {
      try {
        return JSON.parse(el.textContent);
      } catch (e) {
        return null;
      }
    }

    function getSelectedOptions(root) {
      var selected = {};
      root.querySelectorAll('[data-option-position]').forEach(function (el) {
        var pos = Number(el.dataset.optionPosition);
        if (el.tagName === 'SELECT') {
          selected[pos] = el.value;
          return;
        }
        if (el.type === 'radio' && el.checked) {
          selected[pos] = el.value;
        }
      });
      return selected;
    }

    function findVariant(variants, selected, optionCount) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var p = 1; p <= optionCount; p++) {
          var key = 'option' + p;
          if (!v[key]) continue;
          if (selected[p] !== v[key]) {
            match = false;
            break;
          }
        }
        if (match) return v;
      }
      return null;
    }

    function setSlideActive(root, mediaId) {
      if (!mediaId) return;
      var slides = root.querySelectorAll('[data-media-slide]');
      var thumbs = root.querySelectorAll('[data-gallery-thumb]');
      slides.forEach(function (slide) {
        var id = Number(slide.dataset.mediaId);
        var on = id === Number(mediaId);
        slide.classList.toggle('is-active', on);
        slide.toggleAttribute('hidden', !on);
      });
      thumbs.forEach(function (thumb) {
        var id = Number(thumb.dataset.mediaId);
        var on = id === Number(mediaId);
        thumb.classList.toggle('is-active', on);
        thumb.setAttribute('aria-selected', on ? 'true' : 'false');
        if (on) {
          thumb.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }
      });
    }

    function getGalleryMediaIds(root) {
      var slides = root.querySelectorAll('[data-media-slide]');
      return Array.prototype.map.call(slides, function (s) {
        return Number(s.dataset.mediaId);
      });
    }

    function getActiveGalleryMediaId(root) {
      var active = root.querySelector('[data-media-slide].is-active');
      return active ? Number(active.dataset.mediaId) : null;
    }

    function stepGallery(root, direction) {
      var ids = getGalleryMediaIds(root);
      if (ids.length < 2) return;
      var cur = getActiveGalleryMediaId(root);
      var idx = ids.indexOf(cur);
      if (idx < 0) idx = 0;
      var nextIndex =
        direction > 0 ? (idx + 1) % ids.length : (idx - 1 + ids.length) % ids.length;
      setSlideActive(root, ids[nextIndex]);
    }

    function init(root) {
      var dataEl = root.querySelector('[data-product-json]');
      if (!dataEl) return;
      var data = parseJSON(dataEl);
      if (!data || !data.variants) return;

      var variantInput = root.querySelector('[data-variant-id-input]');
      var priceEl = root.querySelector('[data-price]');
      var compareEl = root.querySelector('[data-compare-at]');
      var compareLabel = root.querySelector('[data-compare-label]');
      var unitRow = root.querySelector('[data-unit-row]');
      var inventoryEl = root.querySelector('[data-inventory]');
      var skuRow = root.querySelector('[data-sku-row]');
      var skuEl = root.querySelector('[data-sku]');
      var addBtn = root.querySelector('[data-add-to-cart]');
      var unavailableEl = root.querySelector('[data-unavailable-msg]');
      var qtyInput = root.querySelector('[data-quantity-input]');
      var optionCount = data.optionCount || 0;
      var qtyCap = 99;

      function rebuildQtyOptions(select, maxQtyFromServer) {
        if (!select) return;
        var max = qtyCap;
        if (maxQtyFromServer != null && maxQtyFromServer !== '') {
          var n = Number(maxQtyFromServer);
          if (!isNaN(n) && n > 0) {
            max = Math.min(n, qtyCap);
          }
        }
        if (max < 1) max = 1;
        var prev = Number(select.value);
        if (isNaN(prev) || prev < 1) prev = 1;
        select.innerHTML = '';
        for (var q = 1; q <= max; q++) {
          var opt = document.createElement('option');
          opt.value = String(q);
          opt.textContent = String(q);
          select.appendChild(opt);
        }
        var next = prev > max ? max : prev;
        select.value = String(next);
      }

      function applyVariant(id) {
        var f = data.formatted[String(id)];
        if (!f) return;
        if (variantInput) variantInput.value = id;
        if (priceEl) priceEl.textContent = f.price;
        if (compareEl) {
          if (f.compare_at) {
            compareEl.textContent = f.compare_at;
            compareEl.hidden = false;
            if (compareLabel) compareLabel.hidden = false;
          } else {
            compareEl.textContent = '';
            compareEl.hidden = true;
            if (compareLabel) compareLabel.hidden = true;
          }
        }
        if (unitRow) {
          if (f.unit) {
            unitRow.textContent = f.unit;
            unitRow.hidden = false;
          } else {
            unitRow.textContent = '';
            unitRow.hidden = true;
          }
        }
        if (inventoryEl) {
          if (f.inventory_notice) {
            inventoryEl.textContent = f.inventory_notice;
            inventoryEl.hidden = false;
          } else {
            inventoryEl.textContent = '';
            inventoryEl.hidden = true;
          }
        }
        if (qtyInput) {
          if (f.max_qty) {
            qtyInput.setAttribute('data-qty-max', f.max_qty);
            rebuildQtyOptions(qtyInput, f.max_qty);
          } else {
            qtyInput.removeAttribute('data-qty-max');
            rebuildQtyOptions(qtyInput, null);
          }
        }
        if (skuRow && skuEl) {
          if (f.sku) {
            skuEl.textContent = f.sku;
            skuRow.hidden = false;
          } else {
            skuEl.textContent = '';
            skuRow.hidden = true;
          }
        }
        if (f.featured_media_id) {
          setSlideActive(root, f.featured_media_id);
        }
        if (addBtn) {
          var labelAdd = root.dataset.labelAdd;
          var labelSold = root.dataset.labelSold;
          if (f.available) {
            addBtn.disabled = false;
            if (labelAdd) addBtn.textContent = labelAdd;
          } else {
            addBtn.disabled = true;
            if (labelSold) addBtn.textContent = labelSold;
          }
        }
        if (unavailableEl) {
          unavailableEl.hidden = f.available;
        }
        var url =
          root.dataset.origin +
          root.dataset.productUrl +
          (id ? '?variant=' + encodeURIComponent(id) : '');
        if (window.history && window.history.replaceState) {
          window.history.replaceState({}, '', url);
        }
      }

      root.querySelectorAll('[data-option-position]').forEach(function (input) {
        input.addEventListener('change', function () {
          var selected = getSelectedOptions(root);
          var variant = findVariant(data.variants, selected, optionCount);
          if (variant) {
            applyVariant(variant.id);
          } else {
            if (variantInput) variantInput.value = '';
            if (addBtn) addBtn.disabled = true;
            if (unavailableEl) unavailableEl.hidden = false;
          }
        });
      });

      root.querySelectorAll('[data-gallery-thumb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var mid = btn.dataset.mediaId;
          setSlideActive(root, mid);
        });
      });

      var prevBtn = root.querySelector('[data-gallery-prev]');
      var nextBtn = root.querySelector('[data-gallery-next]');
      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          stepGallery(root, -1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          stepGallery(root, 1);
        });
      }

      root.querySelectorAll('[data-product-accordion]').forEach(function (acc) {
        var trigger = acc.querySelector('[data-accordion-trigger]');
        var panel = acc.querySelector('[data-accordion-panel]');
        if (!trigger || !panel) return;
        trigger.addEventListener('click', function () {
          var expanded = trigger.getAttribute('aria-expanded') === 'true';
          var next = !expanded;
          trigger.setAttribute('aria-expanded', next ? 'true' : 'false');
          panel.hidden = !next;
          acc.classList.toggle('is-open', next);
        });
      });

      root.querySelectorAll('[data-read-more-wrap]').forEach(function (wrap) {
        var btn = wrap.querySelector('[data-read-more-btn]');
        var text = wrap.querySelector('[data-read-more-text]');
        if (!btn || !text) return;
        var labelExpand = wrap.dataset.labelExpand;
        var labelCollapse = wrap.dataset.labelCollapse;
        btn.addEventListener('click', function () {
          var isOpen = text.classList.toggle('is-expanded');
          btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
          if (labelCollapse && labelExpand) {
            btn.textContent = isOpen ? labelCollapse : labelExpand;
          }
        });
      });

    }

    document.querySelectorAll('[data-product-section]').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["split-header-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function syncSplitHeaderStickyTop() {
      var header = document.querySelector('.etsy-header');
      if (!header) {
        document.documentElement.style.removeProperty('--split-header-sticky-top');
        return;
      }
      var rect = header.getBoundingClientRect();
      var offset = Math.max(0, Math.ceil(rect.bottom));
      document.documentElement.style.setProperty('--split-header-sticky-top', offset + 'px');
    }

    function parseTopPx() {
      var raw = getComputedStyle(document.documentElement).getPropertyValue('--split-header-sticky-top').trim();
      var n = parseFloat(raw);
      return isNaN(n) ? 0 : n;
    }

    function updateSplitHeaderFixed() {
      var root = document.querySelector('.split-header-bar-sticky-root');
      if (!root) {
        return;
      }
      var bar = root.querySelector('.split-header-bar-sticky');
      var placeholder = root.querySelector('.split-header-bar-sticky-placeholder');
      if (!bar || !placeholder) {
        return;
      }
      var headerEl = document.querySelector('.etsy-header');
      if (!headerEl) {
        document.documentElement.style.removeProperty('--split-header-sticky-top');
        bar.classList.remove('is-fixed');
        placeholder.style.height = '';
        return;
      }
      syncSplitHeaderStickyTop();
      var topPx = parseTopPx();
      var rootRect = root.getBoundingClientRect();
      var shouldFix = rootRect.top <= topPx;
      if (shouldFix) {
        if (!bar.classList.contains('is-fixed')) {
          placeholder.style.height = bar.offsetHeight + 'px';
        }
        bar.classList.add('is-fixed');
      } else {
        bar.classList.remove('is-fixed');
        placeholder.style.height = '';
      }
    }

    function init() {
      syncSplitHeaderStickyTop();
      updateSplitHeaderFixed();
    }

    init();
    window.addEventListener('resize', function () {
      syncSplitHeaderStickyTop();
      updateSplitHeaderFixed();
    });
    window.addEventListener('scroll', updateSplitHeaderFixed, { passive: true });
    if (typeof ResizeObserver !== 'undefined') {
      var headerEl = document.querySelector('.etsy-header');
      if (headerEl) {
        var ro = new ResizeObserver(function () {
          syncSplitHeaderStickyTop();
          updateSplitHeaderFixed();
        });
        ro.observe(headerEl);
      }
      var barEl = document.querySelector('.split-header-bar-sticky');
      if (barEl) {
        var roBar = new ResizeObserver(function () {
          if (barEl.classList.contains('is-fixed')) {
            var root = document.querySelector('.split-header-bar-sticky-root');
            var ph = root && root.querySelector('.split-header-bar-sticky-placeholder');
            if (ph) {
              ph.style.height = barEl.offsetHeight + 'px';
            }
          }
        });
        roBar.observe(barEl);
      }
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
